import { Box, FormLabel, Grid, TextField, Typography } from '@mui/material';
import { useActividadesContext } from '../../UmmIACategories/Hook/useActividades';

const DescripcionTareaTarea = () => {
  const { promptData, setPromptData} = useActividadesContext();
  const handleIndicaciones = (event) => {
    const nuevaDescripcion = event.target.value;

    setPromptData((prevData) => ({
      ...prevData,
      descripcion_tarea: nuevaDescripcion
    }));
  };

  return (
    <Grid item xs={12} sx={{ mb: 3 }}>
      <Box>

        <Box sx={{ display: 'flex', flexDirection: 'row', }}>
          <Typography sx={{ fontFamily: 'montserrat', fontSize: '1.25rem', fontWeight: 'bold', color: '#336B87' }}>
            Descripción de la tarea
          </Typography>

        </Box>
        <Box>
          <FormLabel sx={{ fontFamily: 'montserrat', fontSize: '0.85rem' }}>
          Describe ideas que te gustaría que fueran consideradas para crear la tarea
          </FormLabel>
        </Box>

        <TextField
          fullWidth
          multiline
          rows={4}
          variant="outlined"
          placeholder="Escribe aquí la descripción de la tarea. Ejemplo: Realiza una infografía muy atractiva para convencer a la comunidad escolar de comer de manera saludable"
          value={promptData.descripcion_tarea}
          onChange={handleIndicaciones}
          InputProps={{
            sx: {
              borderRadius:2,
                fontFamily: 'montserrat',  
                fontSize: '0.75rem',       
                color: '#336B87',   
            },
        }}
          sx={{
            borderRadius:2,
            fontFamily: 'montserrat',
            fontSize: '14px', 
            color: '#336B87',
            '& fieldset': { borderBottomColor: '#Divider' },
            '&:before': {borderBottomColor: '#Divider' },
            '&:after': { borderBottomColor: '#Divider' }
          }}
        />
      </Box>
    </Grid>
  );
};

export default DescripcionTareaTarea;
